import { Button } from "primereact/button"
import { Toolbar } from "primereact/toolbar"
import { PlanCliente } from "../../models/matriz/PlanCliente";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { PlanClienteService } from "../../service/matriz/PlanClienteService";
import { InputComponent } from "../../components/InputComponent";
import { confirmDialog } from "primereact/confirmdialog";
import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";
import { Message } from "primereact/message";
import { Generico } from "../../components/Generico";

export const PlantillaCliente = ({ plan, generic, permss, toast, setRegresar }) => {

    const omodel = new PlanCliente();
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    let loadLazyTimeout = null;
    const [registers, setRegisters] = useState(null);
    const { accionesTbl } = Generico();
    const clienteSrv = new PlanClienteService();
    const [dialogCliente, setDialogCliente] = useState(false);
    const [catalogo, setCatalogo] = useState(null);
    const [resumen, setResumen] = useState(null);
    const [cliente, setCliente] = useState(null);
    const { table, setLoading, setTotalRecords, lazyParams, inDrop, inText, inNumber } = InputComponent({ registers, omodel, generic, errors, control, permss, id: getValues('id') });

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const loadLazyData = () => {
        setLoading(true);
        if (loadLazyTimeout) {
            clearTimeout(loadLazyTimeout);
        }
        loadLazyTimeout = setTimeout(() => {
            let _lazyParams = lazyParams;
            _lazyParams.idp = plan?.id;
            delete _lazyParams.catalogo;
            if (catalogo === null) {
                _lazyParams.catalogo = 'consultar';
            }
            clienteSrv.lista({ lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
                setTotalRecords(res.data.total);
                setRegisters(res.data.registros);
                if (catalogo == null) {
                    setCatalogo(res.data.catalogo);
                    ponderaciones(res.data.resumen);
                }
                setLoading(false);
            });
        });
    }

    const openNew = () => {
        setCliente(null);
        reset(defaultValues);
        setDialogCliente(true);
    }

    const edit = () => {
        clienteSrv.consultar(cliente?.id, plan?.id).then(res => {
            const lista = { estado: generic.estados, es_senial: generic.sino, seccion: catalogo?.seccion, factor: catalogo?.factor, campo_valor: omodel.valores };
            let _plan = res.data;

            Object.keys(lista).forEach(function (key) {
                if (_plan[key] != null) {
                    lista[key].forEach(element => {
                        if (element.cat_id === _plan[key]) {
                            _plan[key] = element;
                        }
                    });
                }
            });
            reset(generic.renewValues(_plan, omodel.model));
            setDialogCliente(true);
        })
    }

    const onSubmit = (data) => {
        data.idp = plan?.id;
        if (getValues('id') == null) {
            clienteSrv.nuevo(data).then(res => {
                generic.funcSuccess(res, toast);
                ponderaciones(res.data);
                loadLazyData();
                setDialogCliente(false);
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        } else {
            clienteSrv.editar(data).then(res => {
                generic.funcSuccess(res, toast);
                ponderaciones(res.data);
                setDialogCliente(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
    }

    const deleteItem = () => {
        confirmDialog({
            message: '¿Esta seguro de eliminar la información?',
            header: 'Confirmar',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Si',
            rejectLabel: 'No',
            accept: () => {
                clienteSrv.eliminar(cliente?.id, plan?.id).then(res => {
                    generic.funcSuccess(res, toast);
                    loadLazyData();
                }).catch(error => {
                    generic.funcDeleteError(error, toast);
                });
            }
        });
    }

    const ponderaciones = (info) => {
        let str = "Total ponderaciones: ";
        info.forEach(itm => {
            str += itm.nombre + ": " + itm.total + " %. "
        });
        setResumen(str);
    }

    const startContent = (
        <>
            <Button icon="pi pi-plus" className="mr-2" title="Nuevo ítem" onClick={() => openNew()} />
        </>
    );

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar)
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { edit() } });
        if (permss?.eliminar)
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { deleteItem() } });

        return [{ label: 'Opciones', items: items }];
    }

    return (
        <>
            <Card style={{ maxWidth: '100%', margin: 'auto' }} title={"Factores Matriz: " + plan?.nombre}>
                <Toolbar className="mb-4" start={startContent}></Toolbar>
                <Message severity="info" text={resumen} style={{ width: '100%' }} />
                {table({ action01: accionesTbl, reg: setCliente, items: itemsMenu() })}

                <br />
                <Button label="Regresar" icon="pi pi-arrow-left" className="p-button-success mr-2" type="button" onClick={() => setRegresar(false)} />
            </Card>

            <Dialog visible={dialogCliente} header={getValues('id') == null ? "Nuevo Item" : "Editar Item"} modal className="p-fluid modal-ssize"
                onHide={e => setDialogCliente(false)} style={{ maxWidth: '600px' }}>
                <br />
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid">
                        {inNumber('orden', 0, false, { min: 0 }, 6)}
                        {inDrop('es_senial', generic.sino, { lab: omodel.optionLabel }, 6)}
                        {inText('nombre', {}, 12)}
                        {inDrop('seccion', catalogo?.seccion, { lab: omodel.optionLabel }, 6)}
                        {inText('form1', {}, 6)}
                        {inDrop('factor', catalogo?.factor, { lab: omodel.optionLabel }, 12)}
                        {inNumber('ponderacion', 2, false, { min: 0 }, 4)}
                        {inDrop('campo_valor', omodel.valores, { lab: omodel.optionLabel }, 4)}
                        {inDrop('estado', generic.estados, { lab: omodel.optionLabel }, 4)}
                        {inText('formula1', {}, 12)}
                        {inText('formula', {}, 12)}
                    </div>

                    {generic.buttonsForms(setDialogCliente)}
                </form>
            </Dialog>
        </>
    )
}
